import axios from 'axios';

export default {
  namespaced: true,
  state: {
    all: [],
  },
  getters: {},
  actions: {
    index({ commit, rootGetters, dispatch }) {
      return axios.get(process.env.VUE_APP_API_URL + 'circuits')
        .then(({ data }) => {
          commit('setCircuits', data);
        });
    },
  },
  mutations: {
    setCircuits(state, circuits) {
      if(!circuits.length > 0) return;

      state.all = circuits;
    },
  },
};
